export default "__VITE_ASSET__D30LXLUv__"